<!-- <div class="lds-dual-ring"></div> -->
<div class="overlay" [ngClass]="{show: show}"></div>
<div class="spanner" [ngClass]="{show: show}">
  <div class="lds-dual-ring"></div>
</div>